import { Navigate, useParams } from 'react-router-dom';

export function SchoolEditPage() {
  const { code } = useParams<{ code: string }>();
  return <Navigate to={`/schools/${code}`} replace />;
}
